var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.333,
    height: 37.333,
    viewBox: "0 0 37.333 37.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2582",
    "data-name": "Group 2582",
    transform: "translate(-170.5 -336.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.067,37.333h11.2c9.333,0,13.067-3.733,13.067-13.067v-11.2C37.333,3.733,33.6,0,24.266,0h-11.2C3.733,0,0,3.733,0,13.067v11.2C0,33.6,3.733,37.333,13.067,37.333Z",
    transform: "translate(170.5 336.5)",
    fill: "#fff100"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2581",
    "data-name": "Group 2581",
    transform: "translate(-686.5 -1858.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,13.267,13.267,0",
    transform: "translate(868.5 2206.5)",
    fill: "none",
    stroke: "#0094d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M13.267,13.267,0,0",
    transform: "translate(868.5 2206.5)",
    fill: "none",
    stroke: "#0094d9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6c45da2ff7c3ef56c3bdc20fc7d57fb3.svg";
export { ForwardRef as ReactComponent };